import { gql } from '@apollo/client';

export const CONFIG_TYPE = {
  DOWNLOAD_LIMIT: 'download_limit',
  DOWNLOAD_EXPIRY: 'download_expiry',
  IS_CUSTOM_PLAYER_ENABLED: 'is_custom_player_enabled',
} as const;

export type ConfigurationItem = {
  cId: string;
  cType: string;
  cValue: string;
};

export type GetConfigurationsData = {
  getConfigurations: {
    configurations: ConfigurationItem[];
  };
};

export const GET_CONFIGURATIONS = gql`
  query GetConfigurations {
    getConfigurations {
      configurations {
        cId
        cType
        cValue
      }
    }
  }
`;

export const mapConfigurations = (configurations: ConfigurationItem[] = []): Record<string, string> =>
  configurations.reduce<Record<string, string>>((acc, { cType, cValue }) => {
    acc[cType] = cValue;
    return acc;
  }, {});
